import {type TokenizerObject} from 'marked';

import {escapeHtml} from './utils';

export const tokenizer: TokenizerObject = {
    del(text) {
        const match = this.rules.inline.del.exec(text);
        if (!match) {
            return;
        }

        const bull = match[1]!.trim();

        if (bull !== '~~') {
            return;
        }

        return false;
    },
    list(text) {
        const match = this.rules.block.list.exec(text);
        if (!match) {
            return;
        }

        const bull = match[1]!.trim();

        /**
         * Не формируем списки, начинающиеся с `+`.
         * https://jira.tcsbank.ru/browse/TIME-2449
         */
        if (bull === '+') {
            return;
        }

        return false;
    },
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore: не совпадают контракты для TokenizerObject.html
    html(text) {
        const match = this.rules.block.html.exec(text);
        if (!match) {
            return;
        }

        return {
            type: 'paragraph',
            pre: match[1] === 'pre' || match[1] === 'script' || match[1] === 'style',
            text: match[0],
            raw: match[0],
            tokens: this.lexer.inline(match[0]),
        };
    },

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore: не совпадают контракты для TokenizerObject.tag
    tag(text) {
        const match = this.rules.inline.tag.exec(text);
        if (!match) {
            return;
        }

        if (!this.lexer.state.inLink && (/^<a /i).test(match[0])) {
            this.lexer.state.inLink = true;
        } else if (this.lexer.state.inLink && (/^<\/a>/i).test(match[0])) {
            this.lexer.state.inLink = false;
        }

        return {
            type: 'text',
            text: escapeHtml(match[0]),
            raw: match[0],
        };
    },
    url(src) {
        const cap = this.rules.inline.url.exec(src);

        if (!cap || cap[2] === '@') {
            return;
        }

        // do extended autolink path validation
        let prevCapZero;
        do {
            prevCapZero = cap[0];
            // eslint-disable-next-line no-underscore-dangle
            cap[0] = this.rules.inline._backpedal.exec(cap[0])?.[0] ?? '';
        } while (prevCapZero !== cap[0]);

        let href;
        const text = cap[0];

        if (cap[1] === 'www.') {
            href = 'http://' + cap[0];
        } else {
            href = cap[0];
        }

        return {
            type: 'link',
            raw: cap[0],
            text,
            href,
            isUrl: true,
            tokens: [
                {
                    type: 'text',
                    raw: text,
                    text,
                },
            ],
        };
    },
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore: не совпадают контракты для TokenizerObject.lheading
    lheading(src: string) {
        const cap = this.rules.block.lheading.exec(src);
        if (cap) {
            if (cap[2] && (cap[2] === '-' || cap[2] === '=')) {
                return {
                    type: 'text',
                    raw: cap[0],
                    text: cap[0],
                    tokens: this.lexer.inline(cap[0]),
                };
            }
            return false;
        }
    },
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore: TIME-13964 переопределен токен для '\~', fix для корректного отображения названия каналов
    escape(src: string) {
        const cap = this.rules.inline.escape.exec(src);
        if (cap?.[1] === '~') {
            return {
                type: 'text',
                raw: '\\~',
                text: '~',
            };
        }
        return false;
    },
};
